import { useState, RefObject, ChangeEvent } from 'react';

export const useSearchModal = (input: RefObject<HTMLInputElement | null>) => {
  const [searchString, setSearchString] = useState('');
  const [isFocused, setIsFocused] = useState(false);
  const [isInputOnFocus, setIsInputOnFocus] = useState(false);
  const [isSubmittedForm, setIsSubmittedForm] = useState(false);

  const onChangeHandler = (e: ChangeEvent<HTMLInputElement>) => {
    setSearchString(e.target.value);
    if (e.target.value.length < 5) {
      setIsSubmittedForm(false);
    }
  };

  const onFocusHandler = (shouldSkipClick?: boolean) => {
    setIsFocused(true);
    setIsInputOnFocus(true);
    if (!shouldSkipClick) input.current?.click();
  };

  const onBlurHandler = () => {
    setIsInputOnFocus(false);
  };

  const defaultCancelHandler = () => {
    setIsFocused(false);
    setSearchString('');
    setIsSubmittedForm(false);
  };

  const onResetHandler = () => {
    setSearchString('');
    input.current?.focus();
    setIsSubmittedForm(false);
  };

  return {
    searchString,
    isFocused,
    onChangeHandler,
    onFocusHandler,
    onBlurHandler,
    defaultCancelHandler,
    onResetHandler,
    isSubmittedForm,
    setIsSubmittedForm,
    isInputOnFocus,
    setSearchString
  };
};
